module.exports = __webpack_public_path__ + "assets/milligazete.5d79d694.svg";